import React, {useEffect, useState} from "react";
import axios from "config/axiosConfig";
import {Link, useSearchParams, useNavigate} from "react-router-dom";
import {Pagination} from "page/util/Pagination";
import {formatBusinessNumber, formatCurrency, formatPhoneNumber} from "page/util/helpers";

export default function Main() {
    const [searchParams, setSearchParams] = useSearchParams();
    const [paginationDto, setPaginationDto] = useState();
    const [contents, setContents] = useState([]);

    const page = searchParams.get('page') || "1";
    const bizName = searchParams.get('bizName');

    const navigate = useNavigate();

    const requestSearch = (e) => {
        const params = {};
        params.page = page;
        params.bizName = bizName;

        axios.get(`/admin/payment-histories`, { params: params })
            .then((res) => {
                setPaginationDto(res.data);
                setContents(res.data.content);
            });
    }

    const setPage = (page) => {
        searchParams.set('page', page);
        setSearchParams(searchParams)
    }

    const displayStatus = (status, reason) => {
        switch (status) {
            case "paid": return <span>결제완료</span>
            case "ready": return "준비됨"
            case "failed": return <span style={{color: 'red'}}>결제실패({reason})</span>
            case "cancelled": return "취소"
            case "partialCancelled": return "부분취소"
            case "expired": return "만료됨"
            case "subscribeCancel": return "구독취소"
            case "noCard": return <span style={{color: 'red'}}>결제실패(카드없음)</span>
            default: return status
        }
    }

    const requestPaymentCancel = (tid) => {
        if(window.confirm('결제 취소 처리 하시겠습니까?')) {
            axios.delete(`/admin/payments/${tid}`)
                .then((res) => {
                    alert("결제가 취소되었습니다.");
                    window.location.reload();
                });
        }
    }

    useEffect(() => {
        requestSearch();
    }, [page]);

    return (
        <div className="App">
            <div className="wrapper">
                <div className="content-wrapper" style={{marginLeft: '0px'}}>
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item active">결제 > 결제이력</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">

                                    <div className="card">
                                        <div className="card-tools" style={{marginTop: '40px'}}>
                                            <div className="form-group row" style={{float: "right"}}>

                                                <label className="col-sm-auto col-form-label"
                                                       style={{marginLeft: '10px'}}>사업장명</label>

                                                <input type="text" className="form-control"
                                                       style={{width: '200px'}}
                                                       onChange={ e=> {
                                                           searchParams.set('bizName', e.target.value);
                                                           setSearchParams(searchParams);
                                                       }}
                                                       onKeyDown={e => {
                                                           if (e.key === 'Enter') {
                                                               setPage(1);
                                                               requestSearch();
                                                           }
                                                       }}
                                                       value={bizName}
                                                       placeholder=''/>

                                                <button type="submit" className="btn btn-info float-right"
                                                        style={{width: '80px', marginLeft:'10px', marginRight: '20px'}}
                                                        onClick={ () => {
                                                            setPage(1);
                                                            requestSearch();
                                                        }}>
                                                    검색
                                                </button>
                                            </div>
                                        </div>
                                        <div className="card-body table-responsive p-0" style={{marginTop: '20px'}}>
                                            <table className="table table-hover text-nowrap"
                                                   style={{textAlign: "center"}}>
                                                <thead>
                                                <tr>
                                                    <th>SEQ</th>
                                                    <th>사업장명</th>
                                                    <th>사업자번호</th>
                                                    <th>상품</th>
                                                    <th>결제금액</th>
                                                    <th>주문상태</th>
                                                    <th>사용기간</th>
                                                    <th>결제일</th>
                                                    <th>관리</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {
                                                    contents && contents.map(item => {
                                                        return (
                                                            <tr key={item.id}>
                                                                <td>{item.id}</td>
                                                                <td>{item.bizName}</td>
                                                                <td>{formatBusinessNumber(item.bizNo)}</td>
                                                                <td>{item.goodsName}</td>
                                                                <td>{formatCurrency(item.amount)}</td>
                                                                <td>{displayStatus(item.status, item.resultMessage)}</td>
                                                                <td>{item.membershipStartDate} ~ {item.membershipEndDate}</td>
                                                                <td>{item.createdAt}</td>
                                                                <td>
                                                                    {
                                                                        item.status === "paid"
                                                                            ?
                                                                            (
                                                                                <button type="button"
                                                                                        className="btn btn-outline-danger"
                                                                                        style={{fontSize: '12px'}}
                                                                                        onClick={ event => requestPaymentCancel(item.tid)}>
                                                                                    결제취소
                                                                                </button>
                                                                            )
                                                                            : (<span></span>)
                                                                    }
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {
                            paginationDto && <Pagination pager={paginationDto} setPage={setPage}/>
                        }

                    </section>

                </div>
            </div>
        </div>
    );
}
